module.exports = __webpack_public_path__ + "media/images/chart-simple-solid-079bef6d90778ce41dc19c54682f0560.svg";